import { InputComponent } from "components/components/Component";
import { TableDefinition } from "../../table";
import { RowDataDataHolder } from "./rowDataHolder";

export class TableRestrictionDataModel {
    private tableDefinition: TableDefinition;
    public parentData: {};
    public filterData: {};

    constructor(tableDefinition: TableDefinition) {
        this.tableDefinition = tableDefinition;
    }

    /**
     * 
     * @param components 
     * @param rowModel 
     * @param id Id for the server action. It is not needed to apply restrictions
     */
    public rowDataHolder(components: InputComponent[], rowModel: any[], id = undefined) {
        return new RowDataDataHolder(components, rowModel, id, this.tableDefinition);
    }
}